import { Popover } from 'antd'
import { useCallback, useMemo, useState, type ReactNode } from 'react'
import { BrowsePopoverContext } from './BrowsePopoverContext'
import './BrowsePopover.css'

type Props = {
  panel: ReactNode
  panelClassName?: string
  disabled?: boolean
  trigger?: 'hover' | 'click'
  children: ReactNode
  block?: boolean
}

export function BrowseHoverPopover({
  panel,
  panelClassName,
  disabled,
  trigger = 'hover',
  block = false,
  children,
}: Props) {
  const [open, setOpen] = useState(false)
  const close = useCallback(() => setOpen(false), [])

  const ctx = useMemo(
    () => ({
      open,
      close,
    }),
    [open, close],
  )

  return (
    <BrowsePopoverContext.Provider value={ctx}>
      <Popover
        open={disabled ? false : open}
        onOpenChange={setOpen}
        trigger={trigger}
        mouseEnterDelay={trigger === 'hover' ? 0.12 : undefined}
        mouseLeaveDelay={trigger === 'hover' ? 0.28 : undefined}
        placement="bottomLeft"
        overlayClassName="app-browse-popover"
        content={
          <div className={`app-browse-popover-panel${panelClassName ? ` ${panelClassName}` : ''}`}>
            {panel}
          </div>
        }
      >
        <div
          className={[
            'app-browse-field-host',
            block ? 'app-browse-field-host--block' : '',
            open ? 'app-browse-field-host--open' : '',
          ]
            .filter(Boolean)
            .join(' ')}
        >
          {children}
        </div>
      </Popover>
    </BrowsePopoverContext.Provider>
  )
}
